import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";

import { disqualifyPatient } from "@/api";
import { useMultiStepFormStore } from "@/stores";

export const usePatient = () => {
  const { clearMultiStepFormData } = useMultiStepFormStore();
  const useDisqualifyPatient = () => {
    return useMutation({
      mutationFn: disqualifyPatient,
      onSuccess: () => {
        toast.success("Disqualified patient");
        clearMultiStepFormData();
      },
      onError: () => {
        toast.error("Could not disqualify Patient");
      },
    });
  };

  return {
    useDisqualifyPatient,
  };
};
